<template>
  <div v-if="show3D" class="molview-overlay">
    <div class="header">
      <span class="title">3D</span>
      <div class="modes">
        <button
          v-for="m in modes"
          :key="m"
          :class="{ active: currentMode === m }"
          @click="changeMode(m)"
        >
          {{ m }}
        </button>
      </div>
      <button class="close" @click="$emit('close-3d')">×</button>
    </div>

    <iframe
      class="viewer"
      @load="onLoaded"
      :src="iframeSrc"
      :key="iframeKey"
      frameborder="0"
      allowfullscreen
    ></iframe>
    <div v-if="isLoading" class="loader">Loading...</div>
  </div>
</template>

<script>
export default {
  name: 'Smiles3DPreview',
  props: {
    smiles: { type: String, default: '' },
    show3D: { type: Boolean, default: false }
  },
  data() {
    return {
      currentMode: 'balls',
      modes: ['balls', 'stick', 'vdw', 'wireframe'],
      isLoading: true
    };
  },
  computed: {
    iframeSrc() {
      if (!this.smiles) return '';
      return `https://embed.molview.org/v1/?mode=${this.currentMode}&smiles=${encodeURIComponent(this.smiles)}`;
    },
    iframeKey() {
      return `${this.currentMode}-${this.smiles}`;
    }
  },
  methods: {
    changeMode(mode) {
      this.currentMode = mode;
      this.isLoading = true;
    },
    onLoaded() {
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.molview-overlay {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: #000000;
  z-index: 1000;
}

.header {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  background: #1a1a1a;
}

.title {
  color: #ffffff;
}

.modes button {
  margin: 0 4px;
  padding: 2px 6px;
  font-size: 12px;
  cursor: pointer;
  color: #000000;
}

.close {
  color: #ffffff;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.loader {
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  color:#fff;
  font-size:14px;
  pointer-events:none;
}

.viewer {
  width: 100%;
  height: 100%;
}
</style>
